import PrivacyPolicy from "./PrivacyPolicy";

function App() {
  return <PrivacyPolicy />;
}

export default App;
